module.exports = __webpack_public_path__ + "c2h4static/img/report-bg-oil@2x.9ed0570.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Result/imgs/report-bg-oil@2x.png
// module id = oLGe
// module chunks = 1